<template>
  <div class="modal-card" id="draggable" style="width: 800px; height: 500px;" >
    <header class="modal-card-head pop-header">
      <p class="modal-card-title tit">
        <span>{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
      </p>
    </header>
    <section class="modal-card-body pop-content">
      <div class="table-area">
        <div class="table-a">
          <table class="table">
            <tbody>
              <tr>
                <td colspan="2"> <!-- SMS 전송 메모 입력 -->
                  <div align="center">
                    <div>
                      <textarea class="input" type="text" @input="changeValue($event)" v-model="form.smsText" style="height: 200px; width: 100%;"/>
                    </div>
                    <br/>
                    {{ form.smsTextLength ? form.smsTextLength : 0 }}/2000 byte
                  </div>
                </td>
                <td colspan="2"> <!-- 특수문자 입력 -->
                  <div style="text-align: center; margin-bottom: 7px;" >
                    <div style="font-size: 15px;">특수문자넣기</div>
                  </div>
                  <table style="width: 350px; align-content: center; background-color: #CCCCCC">
                    <tr style="background-color: #FFFFFF; cursor: pointer;">
                      <td style="width: 12%; align-content: center;"  @click="iconSeledted('♥');"><div align="center">♥</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('♡');"><div align="center">♡</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('★');"><div align="center">★</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('☆');"><div align="center">☆</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('▶');"><div align="center">▶</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('▷');"><div align="center">▷</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('●');"><div align="center">●</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('■');"><div align="center">■</div></td>
                    </tr>
                    <tr style="background-color: #FFFFFF; cursor: pointer;">
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('※');"><div align="center">※</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('▒');"><div align="center">▒</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('♨');"><div align="center">♨</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('™');"><div align="center">™</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('℡');"><div align="center">℡</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('♬');"><div align="center">♬</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('♪');"><div align="center">♪</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('↖');"><div align="center">↖</div></td>
                    </tr>
                    <tr style="background-color: #FFFFFF; cursor: pointer;">
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('＆');"><div align="center">＆</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('＊');"><div align="center">＊</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('◎');"><div align="center">◎</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('◆');"><div align="center">◆</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('◇');"><div align="center">◇</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('♣');"><div align="center">♣</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('♧');"><div align="center">♧</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('☎');"><div align="center">☎</div></td>
                    </tr>
                    <tr style="background-color: #FFFFFF; cursor: pointer;">
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('◀');"><div align="center">◀</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('◁');"><div align="center">◁</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('○');"><div align="center">○</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('□');"><div align="center">□</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('▼');"><div align="center">▼</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('＃');"><div align="center">＃</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('㉿');"><div align="center">㉿</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('◈');"><div align="center">◈</div></td>
                    </tr>
                    <tr style="background-color: #FFFFFF; cursor: pointer;">
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('▣');"><div align="center">▣</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('ª');"><div align="center">ª</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('º');"><div align="center">º</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('☜');"><div align="center">☜</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('☞');"><div align="center">☞</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('§');"><div align="center">§</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('¶');"><div align="center">¶</div></td>
                      <td style="width: 12%; align-content: center;" @click="iconSeledted('⊙');"><div align="center">⊙</div></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <th>기본메세지</th>
                  <el-select v-model="form.smsTextKey">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['smsTextKey']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                <th>발신번호</th>
                <el-input v-model="form.fromNumber" type="text"></el-input>
              </tr>
              <tr>
                <th>고객명</th>
                <el-input v-model="form.toName" type="text"></el-input>
                <th>휴대폰번호</th>
                <el-input v-model="form.toNumber" type="text"></el-input>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="btn-type2">
        <button class="btn-size btn-w-gray" @click="resetButton">초기화</button>
        <button class="btn-size btn-w-gray" style="margin-left: 5px;" @click="sendSMS">SMS 전송</button>
        <button class="btn-size btn-w-gray" style="margin-left: 5px;" @click="closeModal()">닫기</button>
      </div>
    </section>
  </div>
</template>
<script>
import mixin from '@/mixin';

export default {
  name: 'SendSms',
  components: {
  },
  mixins: [ mixin ],
  /* eslint-disable */
  props: {
    //['param'],
    maxValue: {type: Number, default: 2000},
    value: {type: String, default: ''}
  },
  data() {
    return {
      title: 'SMS 전송',
      form: {
        userId: '',
        currentPw: '',
        newPw: '',
        verifyPw: '',
        smsText: '',
        smsTextKey: '',
        smsTextLength: 0,
        fromNumber: '1600-5488',
        toName: '고객',
        toNumber: ''
      },
      combos: {
        'smsTextKey' : [],         // 기본메세지
      },
    }
  },
  mounted() {
    //pop slots modal move
    $(".animation-content").draggable({'cancel':'.modal-card-body'});

    if(!this.$store.state.loginInfo.isAdmin){
      this.form.userId = this.$store.state.loginInfo.loginId;
    }

    this.init();
  },
  watch: {
    'form.smsTextKey'(params) {
      this.changeDefaultValue(params)
    }
  },
  methods: {
    create(){
    },
    closeModal() {
      this.$parent.close();
    },
    init() {
      this.$store.commit('loading');
      // 기본메세지 정보
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 361} })
          .then(response => {
            this.combos['smsTextKey'] = response.data || []
          }).finally(() => {
            this.$store.commit('finish');
      });
    },
    getByteLength(decimal) {
      const LINE_FEED = 10;
      return (decimal >> 7) || (LINE_FEED === decimal) ? 2 : 1
    },
    getByte(str) {
      return str
          .split('')
          .map((s) => s.charCodeAt(0))
          .reduce((prev, unicodeDecimalValue) => prev + this.getByteLength(unicodeDecimalValue), 0)
    },
    changeValue(values) {
      const { value } = values.target
      const maxByte = 2000;
      let isValidByte = this.getByte(value) <= maxByte;

      this.form.smsTextLength = this.getByte(value);

      let validValue = isValidByte ? value :  this.getLimitedByteText(value, maxByte)  // 유효한 값인지 확인
      // value => 유효하면 value 그대로 유효한 값이 됨
      // this.getLimitedByteText => value를 100바이트까지 계산해 잘린 값

      this.$emit('input', validValue)

      if(!isValidByte) {
        this.$forceUpdate()
      }
    },
    changeDefaultValue(params) {
      const defaultKey = params;

      this.$store.commit('loading');
      // 기본메세지 정보
      this.$http.get(`/api/codeMng/detail/catId`, { params: {catId: defaultKey} })
          .then(response => {
            this.form.smsText = response.data[0].catValue1;
          }).finally(() => {
        this.$store.commit('finish');
        this.changeDefaultChk(this.form.smsText);
      });
    },
    changeDefaultChk(value) {
      const maxByte = 2000;
      let isValidByte = this.getByte(value) <= maxByte;

      this.form.smsTextLength = this.getByte(value);

      let validValue = isValidByte ? value :  this.getLimitedByteText(value, maxByte)
      this.$emit('input', validValue)

      if(!isValidByte) { this.$forceUpdate() }
    },
    resetButton(){
      //초기화
      this.form.smsTextLength = 0;
      this.form.smsText = '';
      this.form.smsTextKey = '';
      this.form.toName = '';
      this.form.toNumber = '';
    },
    getLimitedByteText(inputText, maxByte) {
      const characters = inputText.split(''); // inputText.split(''); //this.getByte(inputText)// inputText.split('')
      let validText = ''
      let totalByte = 0

      for (var i = 0; characters.length > i; i++) {
        let character = characters[i]
        let decimal = character.charCodeAt(0)

        let byte = this.getByteLength(decimal) // 글자 한 개가 몇 바이트 길이인지 구해주기

        if (totalByte + byte <= maxByte) {
          totalByte += byte      // 바이트 길이 값을 더해 현재까지의 총 바이트 길이 값을 구함
          validText += character // 글자를 더해 현재까지의 총 문자열 값을 구함
        } else {// 최대 바이트 길이를 넘으면
          this.$swal('warning', '2000byte를 넘었습니다.')
          break                  // for 루프 종료
        }
      }
      this.splitSmsText(params, maxByte)

      return validText
    },
    iconSeledted(value) {
      this.form.smsText += value;
      this.changeDefaultChk(this.form.smsText)
    },
    sendSMS() {
      if( this.form.smsTextLength > 0 && this.form.smsTextLength <= 2000 ) {
        const regex = /[^0-9]/g
        const vToNumber = this.form.toNumber.replace(regex, '');

        if (vToNumber != '' && this.form.toName != '') {
          this.$http.post("/api/common/sendSMS", {
            companyId : this.form.companyId,
            message   : this.form.smsText,               // 발송 문자 내용
            toTelNo   : vToNumber
          }).then(response => {
            console.log(response.data)
            if (response.data === 200) {
              this.$http.post("/api/common/saveSMS", {
                custNm: this.form.toName,
                toTelNo: vToNumber,
                fromTelNo: this.form.fromNumber,
                message: this.form.smsText,
                creatorId: this.$store.state.loginInfo.id
              }).then(res => {
                console.log(res)
              })
            } else {// 요청응답:200 이외의 오류가 뜬 경우 오류 메세지 띄우기
              this.$swal('warning', '문자발송에 실패했습니다.')
            }
          }).finally(() => {
            this.$swal('success', '문자발송이 완료되었습니다.')
            this.resetButton();
          })
        }
        else {
          this.$swal('warning', '고객명과 휴대폰번호를 확인해주세요.')
        }
      } else {
        this.$swal('warning', '문자정보가 없거나, 전송 메세지 크기가 너무 큽니다.')
      }
    }
  },
};
</script>

<style>

.modal-card-head {background: #0065b3;}
.modal-card-title {color:white; font-size:1.2em;}
.modal-close {top: 80px;}

.modal-input {
  width: 100%;
}
</style>
